import { render } from "./HealthCoverageData.vue?vue&type=template&id=6ea9a4ee&ts=true"
import script from "./HealthCoverageData.vue?vue&type=script&lang=ts"
export * from "./HealthCoverageData.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__